enum breakpoints {
  small = '425px',
  medium = '600px',
  large = '1024px',
}

export default breakpoints;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/breakpoints.ts